const values = [
  "icon_sword",
  "icon_shield",
  "icon_arrow",
  "icon_heart",
];
export default values;
